/* eslint-disable max-len */

import { OperationId, startFetch, stopFetch } from '../app/actionCreators';
import {
    openModal,
    setFileBlob,
    setFileMimetype,
    setFileUrl,
} from './actionCreators';
import { AnyAction } from 'redux';
import { selectStubUrl } from '../../selectors/app';
import { ThunkAction } from 'redux-thunk';
import { RootState } from '../../index';
import { ServerFile } from '../../../model';
import { selectTranslate } from '../../selectors/ui';
import { selectUser, selectUserId } from '../../selectors/auth';
import { AppErrorCode, NotificationStatus } from '../app/actionTypes';
import { batch } from 'react-redux';
import { logger } from '../../../helpers/logger';

export const openFileInModalWindow = (
    file: ServerFile,
    previousFileId: number | null,
): ThunkAction<void, RootState, unknown, AnyAction> => {
    return async function thunk(dispatch, getState) {
        const state = getState();
        const user = selectUser(state);
        const userId = selectUserId(state);
        const stubUrl = selectStubUrl(state);
        const translate = selectTranslate(state);

        if (!user || !userId || !stubUrl) {
            return;
        }

        dispatch(
            startFetch({
                id: OperationId.OpenNextcloudFile,
                message: 'Loading Nextcloud file...',
            }),
        );

        const responseMimetype = file.contenttype ?? '';
        dispatch(setFileMimetype(responseMimetype));

        const fileUrl = `${stubUrl}/remote.php/dav/files/${userId}/${file.path}`;
        dispatch(setFileUrl(fileUrl));

        try {
            if (previousFileId !== file.fileId) {
                const response = await fetch(fileUrl, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'sendent-apiurl': user.server,
                        Authorization: `Basic ${btoa(`${user.loginName}:${user.appPassword}`)}`,
                    },
                });

                if (!response.ok) {
                    dispatch(
                        stopFetch({
                            operationId: OperationId.OpenNextcloudFile,
                            errorCode: AppErrorCode.CustomError,
                            message: translate('something_went_wrong'),
                            status: NotificationStatus.Error,
                        }),
                    );
                    return;
                }

                const fileBlob = await response.blob();

                dispatch(setFileBlob(fileBlob));
            }
        } catch (err) {
            logger.error(
                `openFileInModalWindow error: ${
                    err instanceof Error ? err.message : 'unknown'
                }`,
                'Files',
            );
            dispatch(
                stopFetch({
                    operationId: OperationId.OpenNextcloudFile,
                    errorCode: AppErrorCode.CustomError,
                    message: translate('something_went_wrong'),
                    status: NotificationStatus.Error,
                }),
            );
            return;
        }

        batch(() => {
            dispatch(stopFetch({ operationId: OperationId.OpenNextcloudFile }));
            dispatch(openModal());
        });
    };
};
